import http from './utils';
import { prefix } from './constants';
import axios from 'axios';

const CancelToken = axios.CancelToken;
export const getHeroStatsInfo: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/hero/stats`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getHeroChartDate: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/hero/timeline`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getHeroTableDate: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/hero/list`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getNikkeHighGameGPTReport: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<any> = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/hero/gpt_summary`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};

export const getHeroOpinionSummary = (config: {
  data: any;
  cancelToken?: any;
  headers?: any;
}) => {
  return http({
    url: `${prefix}/hero/opinion_summary`,
    method: 'post',
    ...config,
  });
};
